import { render, staticRenderFns } from "./index.vue?vue&type=template&id=5a50ed29"
import script from "./addEditSob.js?vue&type=script&lang=js&external"
export * from "./addEditSob.js?vue&type=script&lang=js&external"
import style0 from "./addEditSob.css?vue&type=style&index=0&prod&lang=css&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports